import React, { useState } from 'react';
import { connect } from 'react-redux';
import { CSSTransition } from 'react-transition-group';

import ButtonBox from './ButtonBox';
import CalculatedRowDetails from '../containers/CalculatedRowDetails';

import { 
    RowFields, 
    PARTIAL_FIELDS 
} from '../Constants';

import { 
  onRowChange,
  onRemoveFocus
} from '../actions/AppActions';

const FormErrorPopup = ({errMsg}) => (
    <div className='c-error'>{errMsg}</div>
)

// Also displays calculated values when hovered over
function BillNumberCell({ fieldValues, rowIndex }) {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <td className="td-div" onMouseOver={() => setIsHovered(true)} onMouseOut={() => setIsHovered(false)}>
            { fieldValues[RowFields.BillNumber.id].value }
            <CalculatedRowDetails fieldValues={fieldValues} rowIndex={rowIndex} isHovered={isHovered} />
        </td>
    )
}

const Row = ({ type, index, onChange, fieldValues, handleRemoveFocus, isFirstRow }) => (
    <tr>
        {/* This <td> is the bill number */}
        <BillNumberCell rowIndex={index} fieldValues={fieldValues}/>
        {[ 
            RowFields.StartDatesOfService, 
            RowFields.EndDatesOfService, 
            RowFields.DateBillSent, 
            RowFields.AmountPaid,
            RowFields.DatePaid,
         ].map( field =>
            <td key={field.id}>
                <div className="td-div">
                    <input 
                        autoFocus={
                            ((field.id === RowFields.StartDatesOfService.id) 
                            || (type === "partial" && field.id === RowFields.AmountPaid.id))
                            && !isFirstRow
                        }
                        onChange={e => onChange(field, e.target.value)} 
                        onBlur={() => handleRemoveFocus(field)}
                        placeholder={field.placeholder}
                        type={field.type}
                        value={fieldValues[field.id].value}
                        disabled={type === "partial" && PARTIAL_FIELDS.some(fieldId => fieldId === field.id)}
                    />

                    <CSSTransition 
                        in={!!fieldValues[field.id].errMsg && fieldValues[field.id].displayError} 
                        timeout={500}
                        classNames="appear"
                        unmountOnExit
                    >
                        <FormErrorPopup errMsg={fieldValues[field.id].errMsg}/>
                    </CSSTransition>
                </div>
            </td>
        )}

        <ButtonBox rowIndex={index} billNumber={fieldValues[RowFields.BillNumber.id].value}/>
    </tr>
)

const mapStateToProps = (state, ownProps) => ({
    fieldValues: state.interestForm.rowData[ownProps.index],
    displayErrorMessages: state.interestForm.displayErrorMessages,
    isFirstRow: state.interestForm.rowData[ownProps.index].id === 0
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    onChange: (field, value) => dispatch(onRowChange(ownProps.index, field, value)),
    handleRemoveFocus: (field) => dispatch(onRemoveFocus(ownProps.index, field))
})

export default connect(
  mapStateToProps, 
  mapDispatchToProps
)(Row);